{
  "pt": {
    "overview": {
      "actions": {
        "select_decision": "Selecionar decisão",
        "select_installment": "Selecionar prestação",
        "select_point_list": "Selecionar lista de defeitos",
        "select_survey": "Selecionar inquérito"
      },
      "table": {
        "labels": {
          "category": "Categoria",
          "level": "Nível",
          "project": "Projeto",
          "status": "Estado",
          "unit": "Unidade"
        }
      }
    }
  }
}
